/**
 * Form utilities for @tanstack/react-form + Zod integration
 */

/**
 * Extract the first error message from TanStack Form + Zod field errors.
 * Only returns an error string when the field has been touched.
 */
export function getFieldError(
  errors: unknown[] | undefined,
  isTouched: boolean
): string | undefined {
  if (!isTouched || !errors || errors.length === 0) return undefined;
  const firstError = errors[0];
  if (typeof firstError === 'string') return firstError;
  if (firstError && typeof firstError === 'object' && 'message' in firstError)
    return (firstError as { message: string }).message;
  return undefined;
}
